__turbopack_context__.v({
  "jumpText": "section-navigation-module-scss-module__uxreqG__jumpText",
  "link": "section-navigation-module-scss-module__uxreqG__link",
  "nav": "section-navigation-module-scss-module__uxreqG__nav",
});
